import React from "react";
import "./Text.css";
import "../theme/privuTheme.css";

/**
 * Custom Text Component - Mimics JDS Text component
 * 
 * Props:
 * - appearance: heading-xxl, heading-xl, heading-l, heading-m, heading-s, heading-xs, heading-xxs,
 *               body-l, body-m, body-s, body-xs, body-xxs, body-l-bold, body-m-bold, body-s-bold, body-xs-bold, body-xxs-bold
 * - color: primary-grey-100, primary-grey-80, primary-grey-60, primary_60, feedback_error_50, etc.
 * - className: additional CSS classes
 * - style: inline styles
 * - children: text content
 */

const Text = ({ 
  appearance = "body-m", 
  color = "primary-grey-100", 
  className = "", 
  style = {}, 
  children,
  ...props 
}) => {
  /* Colours resolve to PrivuBase tokens, so retheming is a one-file change. */
  const colorMap = {
    "primary-grey-100": "var(--privu-grey-900)",
    "primary-grey-80": "var(--privu-grey-500)",
    "primary-grey-60": "var(--privu-grey-400)",
    "primary-grey-50": "var(--privu-grey-500)",
    "primary_grey_100": "var(--privu-grey-900)",
    "primary_grey_80": "var(--privu-grey-500)",
    "primary_grey_60": "var(--privu-grey-400)",
    "grey-100": "var(--privu-grey-900)",
    "primary-inverse": "var(--privu-text-inverse)",
    "primary-20": "var(--privu-primary-300)",
    "primary-50": "var(--privu-primary-500)",
    "primary_50": "var(--privu-primary-500)",
    "primary_60": "var(--privu-primary-500)",
    "primary-100": "var(--privu-primary-700)",
    "feedback_error_50": "var(--privu-error)",
    "feedback_warning_50": "var(--privu-warning)",
    "feedback_success_50": "var(--privu-success)",
    "feedback_info_50": "var(--privu-info)",
  };

  const colorStyle = colorMap[color] || color;

  return (
    <span
      className={`custom-text custom-text-${appearance} ${className}`}
      style={{ color: colorStyle, ...style }}
      {...props}
    >
      {children}
    </span>
  );
};

export default Text;

